const partner = () => import("@/views/partner/Partner.vue");
const createPartner = () => import("@/views/partner/Create.vue");
const viewPartner = () => import("@/views/partner/viewPartner.vue");
const basicInfo = () =>
  import("@/components/Partner/PartnerView/BasicInfo.vue");
const manageOrderById = () => import("@/views/orders/manageOrderById.vue");
const viewSubscription = () =>
  import("@/views/subscriptions/ViewSubscription.vue");
const createSubscription = () =>
  import("@/views/subscriptions/CreateSubsription.vue");
const paymentInfo = () =>
  import("@/views/paymentinfo/partnerPaymentInfoByTenant.vue");
const myPartner = () => import("@/views/partner/Partner.vue");
const invoiceHistory = () => import("@/views/invoice/InvoiceHistory.vue");
const inoviceDetails = () => import("@/views/invoice/InvoiceDetails.vue");
const unbilledInvoice = () =>
  import("@/views/invoice/partnerUnbilledInvoiceByTenant.vue");
const walletStatement = () => import("@/views/wallet/WalletStatement.vue");
const partnerUser = () => import("@/views/userManagement/User.vue");
const viewPartnerUser = () => import("@/views/userManagement/ViewUser.vue");
const editPartnerUser = () => import("@/views/userManagement/EditUser.vue");
const partnerCreateKyc = () => import("@/views/tenant/kycCreate.vue");
const partnerKycUpdate = () => import("@/views/tenant/kycUpdate.vue");
const tenantKycCreate = () => import("@/views/tenant/tenantCreateKyc.vue");
const BulkCreateItem = () => import("@/views/item/BulkCreateItem.vue");
const CreateItem = () => import("@/views/item/CreateItem.vue");
const EditItem = () => import("@/views/item/EditItem.vue");
const CopyItem = () => import("@/views/item/CopyItem.vue");
const ViewItem = () => import("@/views/item/ViewItem.vue");
const Item = () => import("@/views/item/Item.vue");
const viewCommission = () => import("@/views/commission/CommissionAssign.vue");
const createCommission = () =>
  import("@/views/commission/createCommissionAssign.vue");
const deliveryPreference = () =>
  import(
    "@/components/MasterSetup/deliverysetup/DeliveryPreference/DeliveryPreference.vue"
  );
const promotionPreference = () =>
  import(
    "@/components/MasterSetup/Coupon/promotionPreference/promotionPreference.vue"
  );
const advertisement = () => import("@/views/advertisement/Advertisement.vue");

export default {
  path: "partner",
  meta: {
    label: "Partner",
  },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: partner,
    },
    {
      path: "create",
      name: "create-partner",
      meta: {
        label: "Create Partner",
        requiresAuth: true,
      },
      component: createPartner,
    },
    {
      path: "/tenant/Kyc/create",
      name: "tenantCreateKyc",
      meta: {
        label: "Create Kyc",
        requiresAuth: true,
      },
      component: tenantKycCreate,
    },
    {
      path: "view/:id",
      meta: {
        label: "View Partner",
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          meta: {
            requiresAuth: true,
          },
          component: viewPartner,
          alias: "view/:id",
          children: [
            {
              path: "basic-info",
              name: "basic-info",
              meta: {
                label: "Basic Info",
              },
              component: basicInfo,
            },
            {
              path: "view-subscription",
              name: "view-subscription",
              meta: {
                label: "View Subscription",
                requiresAuth: true,
              },
              component: viewSubscription,
            },
            {
              path: "subcription-creation",
              name: "create-subscription",
              meta: {
                label: "Create Subscription",
                requiresAuth: true,
              },
              component: createSubscription,
            },
            {
              path: "payment-info",
              name: "payment-info",
              meta: {
                label: "Payment Info",
                requiresAuth: true,
              },
              component: paymentInfo,
            },
            {
              path: "orders",
              name: "manage-partner-order",
              meta: {
                label: "Manage Partner Order",
                requiresAuth: true,
              },
              component: manageOrderById,
            },
            {
              path: "partners",
              meta: { label: "My Partners" },
              name: "ChildPartnerList",
              component: myPartner,
            },

            {
              path: "view-invoice",
              component: {
                render(c) {
                  return c("router-view");
                },
              },

              children: [
                {
                  path: "",
                  name: "partner-view-invoice",
                  meta: {
                    requiresAuth: true,
                  },
                  component: invoiceHistory,
                },
                {
                  path: "details",
                  meta: {
                    label: "Details",
                    requiresAuth: true,
                  },
                  component: inoviceDetails,
                },
                {
                  path: "unbilled",
                  meta: {
                    label: "Unbilled",
                    requiresAuth: true,
                  },
                  component: unbilledInvoice,
                },
              ],
            },
            {
              path: "wallet-statement",
              name: "wallet-statement",
              meta: {
                label: "Wallet Statement",
                requiresAuth: true,
              },
              component: walletStatement,
            },
            {
              path: "user",
              meta: { label: "User Management" },

              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "partner-user",
                  meta: {
                    requiresAuth: true,
                  },
                  component: partnerUser,
                },
                {
                  path: "/user/view/:userId",
                  name: "ViewUser",
                  meta: {
                    label: "View User",
                    requiresAuth: true,
                  },
                  component: viewPartnerUser,
                },
                {
                  path: "/user/Edit/:id",
                  name: "Edit User",
                  meta: {
                    label: "Edit User",
                    requiresAuth: true,
                  },
                  component: editPartnerUser,
                },
                {
                  path: "/user/Kyc/create",
                  name: "CreateKyc",
                  meta: {
                    label: "Create Kyc",
                    requiresAuth: true,
                  },
                  component: partnerCreateKyc,
                },
                {
                  path: "/user/Kyc/update",
                  name: "UpdateKyc",
                  meta: {
                    label: "Update Kyc",
                    requiresAuth: true,
                  },
                  component: partnerKycUpdate,
                },
              ],
            },
            {
              path: "item",
              meta: { label: "Item" },
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  name: "partner-item",
                  component: Item,
                  meta: {
                    label: "Item List",
                    requiresAuth: true,
                  },
                },
                {
                  path: ":id?",
                  meta: {
                    label: "Edit",
                    requiresAuth: true,
                  },
                  name: "Item",
                  component: CreateItem,
                  props: {
                    context: "edit",
                  },
                },
                {
                  path: "edit/:itemId",
                  meta: {
                    label: "Edit Item",
                    requiresAuth: true,
                  },
                  name: "PartnerEditItem",
                  component: EditItem,
                  props: {
                    context: "edit",
                  },
                },
                {
                  path: "copy/:itemId",
                  meta: {
                    label: "Copy Item",
                    requiresAuth: true,
                  },
                  name: "PartnerCopyItem",
                  component: CopyItem,
                },
                {
                  path: "view/:itemId",
                  meta: {
                    label: "View",
                    requiresAuth: true,
                  },
                  name: "PartnerViewItem",
                  component: ViewItem,
                },

                {
                  path: "create",
                  component: {
                    render(c) {
                      return c("router-view");
                    },
                  },
                  children: [
                    {
                      path: ":id",
                      name: "PartnerCreateItem",
                      meta: {
                        label: "Create Item",
                        requiresAuth: true,
                      },
                      component: CreateItem,
                    },
                  ],
                },
                {
                  path: "bulk",
                  component: {
                    render(c) {
                      return c("router-view");
                    },
                  },
                  children: [
                    {
                      path: "create/:id",
                      meta: {
                        label: "Bulk Create",
                        requiresAuth: true,
                      },
                      name: "Bulkcreate",
                      component: BulkCreateItem,
                    },
                  ],
                },
              ],
            },
            {
              path: "view-commission",
              meta: {
                label: "View Commission",
                requiresAuth: true,
              },
              name: "view-commission",
              component: viewCommission,
            },
            {
              path: "Create-Commission",
              name: "partner-assign-commission",
              meta: {
                label: "Create Commission",
                requiresAuth: true,
              },
              component: createCommission,
            },
            {
              path: "delivery-preference",
              meta: {
                label: "Delivery Preference",
                requiresAuth: true,
              },
              name: "delivery-preference",
              component: deliveryPreference,
            },
            {
              path: "promotion-preference",
              meta: {
                label: "Promotion Preference",
                requiresAuth: true,
              },
              name: "promotion-preference",
              component: promotionPreference,
            },
            {
              path: "advertisement",
              name: "Advertisement",
              meta: {
                label: "Advertisements",
                requiresAuth: true,
              },
              component: advertisement,
            },
          ],
        },
      ],
    },
  ],
};
